import React, { useEffect, useRef } from 'react';
import InputMask from 'react-input-mask';
import { connect, useSelector } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { changeFormField, setNewForm } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { getFieldsForGaPlasticPin, validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';

import { PinContainer, PinInputContainer, PinInputUnderline } from './styles';

const PinCreateScreen = (props) => {
    const first = useRef(null);
    const second = useRef(null);
    const third = useRef(null);
    const fourth = useRef(null);

    const { createLater, createPinSubTitle = '', linkedConfirmButton } = useSelector(({ messages }) => messages.pageMessages);
    const fields = useSelector(({ form }) => form[props.formName]?.fields);
    const { first_pin_field = {}, second_pin_field = {}, third_pin_field = {}, fourth_pin_field = {} } = fields || {};

    useEffect(() => {
        props.setNewForm(props.formName, getFieldsForGaPlasticPin(), '').then(() => props.toggleSpinner(false));
    }, []);

    useEffect(() => {
        first.current?.focus();
    }, [first.current]);

    const onChangeHandler = ({ target: { name, value } }, field) => {
        validationAndUpdateValue(props.formName, value, field, props.changeFormField).then(() => {
            if (value && name !== '4') {
                setFocus(name);
            }
        });
    };

    const setFocus = (name, back = false) => {
        const currPosition = +name;
        const nextPosition = back ? currPosition - 1 : currPosition + 1;
        const newRefContainer = helper[String(nextPosition)].ref;
        newRefContainer.current.focus();
    };

    const onKeyDownHandler = ({ key, target: { value, name } }) => {
        if (key === 'Backspace' && name !== '1' && !value) {
            setFocus(name, true);
        }
    };
    const onClickCreateLater = () => {
        const isEmptyFields = !first_pin_field?.value && !second_pin_field?.value && !third_pin_field?.value && !fourth_pin_field?.value;
        if (!isEmptyFields) {
            props.onClickCreateLater();
        }
    };
    const onClickHandler = () => {
        const isNotEmptyFields = !!first_pin_field?.value && !!second_pin_field?.value && !!third_pin_field?.value && !!fourth_pin_field?.value;
        if (isNotEmptyFields) {
            props.onClickCreateLater();
        }
    };
    const helper = {
        1: {
            name: '1',
            field: first_pin_field,
            ref: first,
        },
        2: {
            name: '2',
            field: second_pin_field,
            ref: second,
        },
        3: {
            name: '3',
            field: third_pin_field,
            ref: third,
        },
        4: {
            name: '4',
            field: fourth_pin_field,
            ref: fourth,
        },
    };
    if (fields && Object.keys(fields).length > 0) {
        return (
            <CommonPage
                showChat={false}
                stateOptions={{ isGA: true }}
                //change variant="tertiary"
                rightHeaderComponent={<Button type="link" size="tight" variant="hidden" onClick={onClickCreateLater} caption={createLater} />}
                backUrl={props.backUrl}
                onClickIcon={props.onClickArrow}
            >
                <HeaderPanel title={props.title} subtitle={createPinSubTitle} />
                <PinContainer>
                    {Object.values(helper).map(({ name, field, ref }, index) => {
                        return (
                            <PinInputContainer key={`${name}${index}`}>
                                <InputMask
                                    mask={'9'}
                                    maskChar={null}
                                    value={field.value || ''}
                                    name={name}
                                    onKeyDown={(e) => onKeyDownHandler(e)}
                                    onChange={(e) => onChangeHandler(e, field)}
                                >
                                    {(inputProps) => <input {...inputProps} ref={ref} />}
                                </InputMask>
                                <PinInputUnderline />
                            </PinInputContainer>
                        );
                    })}
                </PinContainer>
                <FixedBottomPanel isRightAligned>
                    <Button type="button" caption={linkedConfirmButton} raised={true} onClick={onClickHandler} />
                </FixedBottomPanel>
            </CommonPage>
        );
    } else {
        return null;
    }
};
export default connect(null, { changeFormField, setNewForm, toggleSpinner })(PinCreateScreen);
